// extracted by mini-css-extract-plugin
module.exports = {"invitecell":"CustomDropDown_invitecell__2EjIg"};